// extracted by mini-css-extract-plugin
export default {"calendar":"tabs-module--calendar--I5IFe","tabsHeader":"tabs-module--tabsHeader--7VCQN","tabContent":"tabs-module--tabContent--ZS0x9","providers":"tabs-module--providers--w3r3c"};